import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider, Container, CircularProgress } from '@mui/material';
import App from './App';
import Login from './components/Login';
import theme from './utils/theme';
import '@fontsource/material-icons';

function Root() {
  const [user, setUser] = React.useState(null);
  const [authError, setAuthError] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const userParam = urlParams.get('user');
    const errorParam = urlParams.get('error');

    if (userParam) {
      try {
        const userData = JSON.parse(decodeURIComponent(userParam));
        sessionStorage.setItem('user', JSON.stringify(userData));
        setUser(userData);
        // Clean up URL
        window.history.replaceState({}, document.title, "/");
      } catch (e) {
        console.error("Failed to parse user data from URL", e);
        setAuthError("Authentication failed. Please try again.");
      }
    } else if (errorParam) {
      setAuthError(errorParam);
    } else {
      const storedUser = sessionStorage.getItem('user');
      if (storedUser) {
        try {
          setUser(JSON.parse(storedUser));
        } catch(e) {
          console.error('Failed to parse user from sessionStorage', e);
          sessionStorage.removeItem('user'); // Clear corrupted data
        }
      }
    }
    setLoading(false);
  }, []);

  const handleLogout = () => {
    sessionStorage.removeItem('user');
    setUser(null);
    window.location.href = '/';
  };

  if (loading) {
    return <ThemeProvider theme={theme}><Container sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><CircularProgress /></Container></ThemeProvider>;
  }

  return user ? <App user={user} onLogout={handleLogout} /> : <Login error={authError} />;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);